import React from "react";

import HeaderTitle from "./header-title";
import SolutionThink from "../atoms/solution-think";
import SolutionCreate from "../atoms/solution-create";
import SolutionAccelerate from "../atoms/solution-accelerate";

class SolutionScrollHeader extends React.Component {
  render() {
    return (
      <section className="solution-scroll-header">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="solution-scroll-header-title">
                <HeaderTitle
                  title="We Think"
                  active={this.props.activeIndex === 0}
                  withBorder={true}
                />
                <HeaderTitle
                  title="We Create"
                  active={this.props.activeIndex === 1}
                  withBorder={true}
                />
                <HeaderTitle
                  title="We Accelerate"
                  active={this.props.activeIndex === 2}
                  withBorder={true}
                />
              </div>
            </div>

            <div className="col-md-5">
              <div className="solution-scroll-header-icon">
                <SolutionThink
                  active={this.props.activeIndex === 0}
                  onClick={() => this.props.setActiveIndex(0)}
                />
                <hr />
                <SolutionCreate
                  active={this.props.activeIndex === 1}
                  onClick={() => this.props.setActiveIndex(1)}
                />
                <hr />
                <SolutionAccelerate
                  active={this.props.activeIndex === 2}
                  onClick={() => this.props.setActiveIndex(2)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SolutionScrollHeader;
